let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1lXr0")).then(() => parcelRequire('1brNQ'));